import { Injectable, Provider } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

/**
 * Sumber indeks halaman untuk tabel di dalam modal Monitoring.
 *
 * `app-mai-material-bottom-table` mengambil indeks halaman dari query param `page` pada
 * `ActivatedRoute`. Di halaman Detail Target Distributor, URL itu sudah dipakai tabel
 * distributor, sehingga paginator di dalam modal akan menampilkan halaman milik tabel
 * induk — bukan halaman datanya sendiri.
 *
 * Kelas ini menggantikan `ActivatedRoute` khusus di subtree komponen modal, sehingga
 * paginator membaca halaman lokal tanpa perlu mengubah komponen shared-nya.
 */
@Injectable()
export class MonitoringPaginatorRoute {
  readonly queryParams = new BehaviorSubject<Params>({ page: 0 });

  setPage(page: number): void {
    this.queryParams.next({ page });
  }
}

/** Dipasang di `providers` komponen yang memuat tabel di dalam modal Monitoring. */
export const MONITORING_PAGINATOR_ROUTE_PROVIDERS: Provider[] = [MonitoringPaginatorRoute, { provide: ActivatedRoute, useExisting: MonitoringPaginatorRoute }];
